export const component_array = {

    "text": {
        "type": "text",
        "lable": "Text",
        "name": "text",
        "description": "",
        "placeHolder": "",
        "defaultValue": "",
        "ai_support": false,
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "controlClass": "",
        "input_type": "text",
        "dynamic": false,
        "conditions": false,
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "class": "",
    },

    "preview": {
        "type": "preview",
        "lable": "Preview",
        "name": "preview",
    },

    "number": {
        "type": "number",
        "lable": "Number",
        "name": "number",
        "description": "",
        "placeHolder": "",
        "defaultValue": "0",
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "controlClass": "",
        "responsive": false,
        "selectors": "",
        "selector_value": "",
        "dynamic": false,
        "number_setting": { "min": "0", "max": "100", "step": "1" },
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "wysiwyg": {
        "type": "wysiwyg",
        "lable": "Wysiwyg",
        "name": "wysiwyg",
        "description": "",
        "defaultValue": "",
        "ai_support": false,
        "showLable": true,
        "lableBlock": true,
        "controlClass": "",
        "separator": "default",
        "dynamic": false,
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "code": {
        "type": "code",
        "lable": "Code",
        "name": "code",
        "description": "",
        "defaultValue": "",
        "ai_support": false,
        "showLable": true,
        "lableBlock": true,
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "rows": "5",
        "dynamic": false,
        "language": "html",
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "hidden": {
        "type": "hidden",
        "lable": "Hidden",
        "name": "hidden",
        "defaultValue": "",
    },

    "choose": {
        "type": "choose",
        "lable": "Choose",
        "name": "choose",
        "description": "",
        "align_defaultValue": "",
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "align_option": [{ "align_lable": "label", "align_value": "value", "align_icon": "eicon-text-align-left", "align_title": "", "align_svg": "" },],
        "toggle": false,
        "controlClass": "",
        "responsive": false,
        "conditions": false,
        "selectors": "",
        "selector_value": "",
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",

        //gutrnberg
        "alignmentType": "content",
    },

    "datetime": {
        "type": "datetime",
        "lable": "Date Time",
        "name": "datetime",
        "description": "",
        "defaultValue": "",
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "gallery": {
        "type": "gallery",
        "lable": "Gallery",
        "name": "gallery",
        "description": "",
        "defaultValue": wdkitData.WDKIT_URL + "assets/images/jpg/placeholder.png",
        "showLable": true,
        "lableBlock": true,
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "media": {
        "type": "media",
        "lable": "Media",
        "name": "media",
        "description": "",
        "defaultValue": wdkitData.WDKIT_URL + "assets/images/jpg/placeholder.png",
        "media_types": [],
        "ai_support": false,
        "showLable": true,
        "lableBlock": true,
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "dynamic": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "iconscontrol": {
        "type": "iconscontrol",
        "lable": "Icons Control",
        "name": "iconscontrol",
        "description": "",
        "defaultValue": "",
        "showLable": true,
        "lableBlock": true,
        "parent_class": true,
        "separator": "default",
        "skin": "media",
        "exclude_inline_options": ['none'],
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "background": {
        "type": "background",
        "lable": "Background",
        "name": "background",
        "selector": "",
        "separator": "default",
        "types": [`"classic"`, `"gradient"`],
        "fields_options": [],
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "border": {
        "type": "border",
        "lable": "Border",
        "name": "border",
        "selector": "",
        "controlClass": "",
        "separator": "default",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "boxshadow": {
        "type": "boxshadow",
        "lable": "Box Shadow",
        "name": "boxshadow",
        "selector": "",
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "textshadow": {
        "type": "textshadow",
        "lable": "Text Shadow",
        "name": "textshadow",
        "separator": "default",
        "selector": "",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "color": {
        "type": "color",
        "lable": "Color",
        "name": "color",
        "description": "",
        "defaultValue": "",
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "alpha": true,
        "global": true,
        "selectors": "",
        "selector_value": "",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "cssfilter": {
        "type": "cssfilter",
        "lable": "CSS Filter",
        "name": "cssfilter",
        "selector": "",
        "separator": "default",
        "conditions": false,
        "controlClass": "",
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "dimension": {
        "type": "dimension",
        "lable": "Dimension",
        "name": "dimension",
        "description": "",
        "showLable": true,
        "lableBlock": true,
        "separator": "default",
        "dimension_units": ['px'],
        "dimension_defaultValue": { 'top': 0, 'right': 0, 'bottom': 0, 'left': 0, 'unit': 'px', 'isLinked': true },
        "selectors": "",
        "responsive": false,
        "selector_value": "",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "typography": {
        "type": "typography",
        "lable": "Typography",
        "name": "typography",
        "separator": "default",
        "conditions": false,
        "selector": "",
        "controlClass": "",
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "repeater": {
        "type": "repeater",
        "lable": "Repeater",
        "name": "repeater",
        "description": "",
        "showLable": true,
        "lableBlock": true,
        "separator": "default",
        "fields": [],
        "title_field": "Repeater Title",
        "prevent_empty": true,
        "defaultCount": 1,
        "repeater_type": "Old",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "heading": {
        "type": "heading",
        "lable": "Heading",
        "name": "heading",
        "separator": "default",
        "conditions": false,
        "controlClass": "",
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "divider": {
        "type": "divider",
        "lable": "Divider",
        "name": "divider",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "rawhtml": {
        "type": "rawhtml",
        "lable": "RawHtml",
        "name": "rawhtml",
        "description": "",
        "defaultValue": "",
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": 'wdk_senitize_js',
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "slider": {
        "type": "slider",
        "lable": "Slider",
        "name": "slider",
        "description": "",
        "placeHolder": "",
        "slider_defaultValue": ["px", 10],
        "separator": "default",
        "controlClass": "",
        "size_units": [
            { "type": "px", "checked": true, "min": 0, "max": 10, "step": 1 },
            { "type": "%", "checked": false, "min": 0, "max": 10, "step": 1 },
            { "type": "em", "checked": false, "min": 0, "max": 10, "step": 1 },
            { "type": "rem", "checked": false, "min": 0, "max": 10, "step": 1 },
            { "type": "deg", "checked": false, "min": 0, "max": 10, "step": 1 },
            { "type": "vh", "checked": false, "min": 0, "max": 10, "step": 1 },
        ],
        "show_unit": true,
        "showLable": true,
        "lableBlock": true,
        "conditions": false,
        "dynamic": false,
        "selectors": "",
        "selector_value": "",
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "responsive": true,
    },

    "select": {
        "type": "select",
        "lable": "Select",
        "name": "select",
        "description": "",
        "select_defaultValue": ['value-0', 'label-0'],
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "controlClass": "",
        "options": [{ "value": "value-0", "lable": "label-0", "svg": "svg-0" }],
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "", "svg": "svg-0" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "selecttemplate": {
        "type": "selecttemplate",
        "lable": "Select Template",
        "name": "selecttemplate",
        "description": "",
        "s_template_defaultValue": 'select template',
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "", "svg": "svg-0" },] },
    },

    "cpt": {
        "type": "cpt",
        "lable": "Post Type",
        "name": "cpt",
        "description": "Author details aren't displayed for the \"Product\" post type.",
        "select_defaultValue": ['select type', 'Select Type'],
        "options": [{ "value": "select type", "lable": "Select Type", }],
        "fields": [
            {
                "type": "number",
                "lable": "Max Post",
                "name": "max_post",
                "description": "",
                "placeHolder": "",
                "defaultValue": "10",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "responsive": false,
                "selectors": "",
                "selector_value": "",
                "dynamic": false,
                "number_setting": { "min": "0", "max": "100", "step": "1" },
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
            {
                "type": "text",
                "lable": "Include Product(s)",
                "name": "include",
                "description": "",
                "placeHolder": "product_id",
                "defaultValue": "",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "dynamic": false,
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
            {
                "type": "text",
                "lable": "Exclude Product(s)",
                "name": "exclude",
                "description": "",
                "placeHolder": "product_id",
                "defaultValue": "",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "dynamic": false,
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
            {
                "type": "select",
                "lable": "Order",
                "name": "order",
                "description": "",
                "select_defaultValue": ['desc', 'Descending'],
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                'options': [
                    { "value": 'desc', "lable": 'Descending' },
                    { "value": 'asc', "lable": 'Ascending' },
                ],
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "", "svg": "svg-0" },] },
            },
            {
                "type": "select",
                "lable": "Order By",
                "name": "order_by",
                "description": "",
                "select_defaultValue": ['date', 'Date'],
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                'options': [{ "value": "", "lable": "Select", }],
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "", "svg": "svg-0" },] },
            },
            {
                "type": "number",
                "lable": "Max Category",
                "name": "max_cat",
                "description": "",
                "placeHolder": "",
                "defaultValue": "3",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "responsive": false,
                "selectors": "",
                "selector_value": "",
                "dynamic": false,
                "number_setting": { "min": "0", "max": "100", "step": "1" },
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
            {
                "type": "number",
                "lable": "Max Tag",
                "name": "max_tag",
                "description": "",
                "placeHolder": "",
                "defaultValue": "3",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "responsive": false,
                "selectors": "",
                "selector_value": "",
                "dynamic": false,
                "number_setting": { "min": "0", "max": "100", "step": "1" },
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
        ],
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
    },

    "product_listing": {
        "type": "product_listing",
        "lable": "Product Listing",
        "name": "product_listing",
        "description": "",
        "fields": [
            {
                "type": "number",
                "lable": "Max Post",
                "name": "max_post",
                "description": "",
                "placeHolder": "",
                "defaultValue": "10",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "responsive": false,
                "selectors": "",
                "selector_value": "",
                "dynamic": false,
                "number_setting": { "min": "0", "max": "100", "step": "1" },
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
            {
                "type": "text",
                "lable": "Include Product(s)",
                "name": "include",
                "description": "",
                "placeHolder": "product_id",
                "defaultValue": "",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "dynamic": false,
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
            {
                "type": "text",
                "lable": "Exclude Product(s)",
                "name": "exclude",
                "description": "",
                "placeHolder": "product_id",
                "defaultValue": "",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "dynamic": false,
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
            {
                "type": "select",
                "lable": "Order",
                "name": "order",
                "description": "",
                "select_defaultValue": ['desc', 'Descending'],
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                'options': [
                    { "value": 'desc', "lable": 'Descending' },
                    { "value": 'asc', "lable": 'Ascending' },
                ],
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "", "svg": "svg-0" },] },
            },
            {
                "type": "select",
                "lable": "Order By",
                "name": "order_by",
                "description": "",
                "select_defaultValue": ['date', 'Date'],
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                'options': [
                    { "value": 'none', "lable": 'None' },
                    { "value": 'id', "lable": 'ID' },
                    { "value": 'author', "lable": 'Author' },
                    { "value": 'title', "lable": 'Title' },
                    { "value": 'name', "lable": 'Name (slug)' },
                    { "value": 'date', "lable": 'Date' },
                    { "value": 'modified', "lable": 'Modified' },
                    { "value": 'rand', "lable": 'Random' },
                    { "value": 'comment_count', "lable": 'Comment Count' },
                    { "value": 'menu_order', "lable": 'Default Menu Order' },
                ],
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "", "svg": "svg-0" },] },
            },
            {
                "type": "number",
                "lable": "Max Category",
                "name": "max_cat",
                "description": "",
                "placeHolder": "",
                "defaultValue": "3",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "responsive": false,
                "selectors": "",
                "selector_value": "",
                "dynamic": false,
                "number_setting": { "min": "0", "max": "100", "step": "1" },
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
            {
                "type": "number",
                "lable": "Max Tag",
                "name": "max_tag",
                "description": "",
                "placeHolder": "",
                "defaultValue": "3",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "responsive": false,
                "selectors": "",
                "selector_value": "",
                "dynamic": false,
                "number_setting": { "min": "0", "max": "100", "step": "1" },
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
        ],
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
    },

    "taxonomy": {
        "type": "taxonomy",
        "lable": "Taxonomy",
        "name": "taxonomy",
        "description": "",
        "select_defaultValue": ['select type', 'Select Type'],
        "options": [{ "value": "select type", "lable": "Select Type", }],
        "fields": [
            {
                "type": "select",
                "lable": "Post Type",
                "name": "post_type",
                "description": "",
                "select_defaultValue": ['select type', 'Select Type'],
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "options": [{ "value": "select type", "lable": "Select Type", }],
                "conditions": false,
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "", "svg": "svg-0" },] },
            },
            {
                "type": "number",
                "lable": "Max Post",
                "name": "max_post",
                "description": "",
                "placeHolder": "",
                "defaultValue": "10",
                "showLable": true,
                "lableBlock": false,
                "separator": "default",
                "controlClass": "",
                "responsive": false,
                "selectors": "",
                "selector_value": "",
                "dynamic": false,
                "number_setting": { "min": "0", "max": "100", "step": "1" },
                "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
            },
        ],
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
    },

    "select2": {
        "type": "select2",
        "lable": "Select2",
        "name": "select2",
        "description": "",
        "select2_defaultValue": [],
        "showLable": true,
        "lableBlock": false,
        "controlClass": "",
        "separator": "default",
        "multiple": true,
        "options": [{ "value": "value-0", "lable": "label-0" }],
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "textarea": {
        "type": "textarea",
        "lable": "Textarea",
        "name": "textarea",
        "description": "",
        "placeHolder": "",
        "defaultValue": "",
        "controlClass": "",
        "ai_support": false,
        "showLable": true,
        "lableBlock": false,
        "dynamic": false,
        "separator": "default",
        "rows": "2",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "url": {
        "type": "url",
        "lable": "Url",
        "name": "url",
        "description": "",
        "placeHolder": "",
        "defaultValue": "",
        "controlClass": "",
        "url_options": true,
        "url_options_array": ['url', 'is_external', 'nofollow'],
        "is_external": false,
        "nofollow": false,
        "custom_attributes": "",
        "showLable": true,
        "lableBlock": true,
        "dynamic": false,
        "separator": "default",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "sanitizer_value": "wdk_senitize_js",
        "sanitizer_dropdown_value": "wdk_senitize_js",
    },

    "switcher": {
        "type": "switcher",
        "lable": "Switcher",
        "name": "switcher",
        "description": "",
        "defaultValue": "",
        "controlClass": "",
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "label_on": "yes",
        "label_off": "no",
        "return_value": "yes",
        "responsive": false,
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "popover": {
        "type": "popover",
        "lable": "Popover",
        "name": "popover",
        "description": "",
        "fields": [],
        "showLable": true,
        "lableBlock": false,
        "return_value": "",
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "class": "",
    },

    "normalhover": {
        "type": "normalhover",
        "lable": "Normal Hover",
        "name": "normalhover",
        "defaultValue": "normal",
        "nha_type": "normal",
        "tabTitle": "normal",
        "description": "",
        "nha_array": ['normal', 'hover'],
        "nha_array_lable": ['Normal', 'Hover'],
        "fields": [],
        "showLable": true,
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "class": "",
    },

    "icon": {
        "type": "icon",
        "lable": "Icon",
        "name": "icon",
        "description": "",
        "defaultValue": "",
        "showLable": true,
        "separator": "default",
        "controlClass": "",
        "responsive": false,
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "headingtags": {
        "type": "headingtags",
        "lable": "Heading Tags",
        "name": "headingtags",
        "description": "",
        "select_defaultValue": ['h1', 'H1'],
        "options": [{ "value": "h1", "lable": "H1" }, { "value": "h2", "lable": "H2" }, { "value": "h3", "lable": "H3" }, { "value": "h4", "lable": "H4" }, { "value": "h5", "lable": "H5" }, { "value": "h6", "lable": "H6" }],
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "class": "",
    },

    "gradientcolor": {
        "type": "gradientcolor",
        "lable": "Gradient Color",
        "name": "gradientcolor",
        "description": "",
        "defaultValue": "linear-gradient(90deg, rgb(6, 147, 227) 0%, rgb(155, 81, 224) 100%)",
        "separator": "default",
        "lableBlock": false,
        "selectors": "",
        "selector_value": "",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "sortable": {
        "type": "sortable",
        "lable": "Sortable",
        "name": "sortable",
        "description": "",
        "placeHolder": "",
        "defaultValue": "",
        "controlClass": "",
        "showLable": true,
        "lableBlock": false,
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "tab": {
        "type": "tab",
        "lable": "Tab",
        "name": "tab",
        "description": "",
        "placeHolder": "",
        "defaultValue": "",
        "controlClass": "",
        "showLable": true,
        "lableBlock": false,
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "toggle": {
        "type": "toggle",
        "lable": "Toggle",
        "name": "toggle",
        "description": "",
        "defaultValue": "",
        "controlClass": "",
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "label_on": "yes",
        "label_off": "no",
        "return_value": "yes",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "alert": {
        "type": "alert",
        "lable": "Alert",
        "name": "alert",
        "description": "",
        "alert_type": "warning",
        "separator": "default",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "notice": {
        "type": "notice",
        "lable": "Notice",
        "name": "notice",
        "dismissible": true,
        "description": "",
        "notice_type": "warning",
        "separator": "default",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    "deprecatednotice": {
        "type": "deprecatednotice",
        "lable": "Deprecated Notice",
        "name": "deprecatednotice",
        "showLable": true,
        "lableBlock": false,
        "separator": "default",
        "conditions": false,
        "deprecatedValue": [{ 'Widget': 'your-old-widget' }, { 'Since': '1.0.0' }, { "Last": "1.0.1" }, { "Plugin": "Your Great Plugin" }, { "Replacement": "your-new-widget" }],
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    },

    // Extra elements for elementor

    "svg": {
        "type": "svg",
        "lable": "Svg",
        "name": "svg",
        "description": "",
        "defaultValue": "",
        "separator": "default",
        "lableBlock": false,
        "selectors": "",
        "selector_value": "",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" }] },
    },

    "align": {
        "type": "align",
        "lable": "Align",
        "name": "align",
        "description": "",
        "defaultValue": "",
        "alignType": "text-align",
        "showLable": true,
        "lableBlock": false,
        "align_type": "default",
        "selectors": "",
        "separator": "default",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
        "class": "",
    },

    "query": {
        "type": "query",
        "lable": "Query",
        "name": "query",
        "description": "",
        "defaultValue": "",
        "showLable": true,
        "separator": "default",
        "controlClass": "",
        "conditions": false,
        "condition_value": { "relation": "or", "values": [{ "name": "", "operator": "==", "value": "" },] },
    }
}

export const component_link = {
    "text": generateComponentLinks("text", "2XXLlqlzKkw"),
    "number": generateComponentLinks("number", ""),
    "wysiwyg": generateComponentLinks("wysiwyg", ""),
    "code": generateComponentLinks("code", ""),
    "hidden": generateComponentLinks("hidden", ""),
    "choose": generateComponentLinks("choose", "Kl4Qf1vy4bs"),
    "datetime": generateComponentLinks("datetime", ""),
    "gallery": generateComponentLinks("gallery", ""),
    "media": generateComponentLinks("media", "F4r3cCPy7jA"),
    "iconscontrol": generateComponentLinks("iconscontrol", "T2kJk41q1W0"),
    "background": generateComponentLinks("background", ""),
    "border": generateComponentLinks("border", ""),
    "boxshadow": generateComponentLinks("boxshadow", ""),
    "textshadow": generateComponentLinks("textshadow", ""),
    "color": generateComponentLinks("color", ""),
    "cssfilter": generateComponentLinks("cssfilter", ""),
    "dimension": generateComponentLinks("dimension", "yc6JG9ldy3M"),
    "typography": generateComponentLinks("typography", "N9-0IYLyeho"),
    "repeater": generateComponentLinks("repeater", ""),
    "heading": generateComponentLinks("heading", ""),
    "divider": generateComponentLinks("divider", ""),
    "rawhtml": generateComponentLinks("rawhtml", ""),
    "slider": generateComponentLinks("slider", "xrAdPPeJpYk"),
    "select": generateComponentLinks("select", "YeCPqUMx3Cw"),
    "selecttemplate": generateComponentLinks("selecttemplate", ""),
    "cpt": generateComponentLinks("cpt", ""),
    "product_listing": generateComponentLinks("product_listing", ""),
    "taxonomy": generateComponentLinks("taxonomy", ""),
    "select2": generateComponentLinks("select2", ""),
    "textarea": generateComponentLinks("textarea", ""),
    "url": generateComponentLinks("url", "wOlHlJFb4hk"),
    "switcher": generateComponentLinks("switcher", "mANZ30J5-2w"),
    "popover": generateComponentLinks("popover", ""),
    "normalhover": generateComponentLinks("normalhover", "SFOifoHKlrU"),
    "icon": generateComponentLinks("icon", ""),
    "headingtags": generateComponentLinks("headingtags", ""),
    "gradientcolor": generateComponentLinks("gradientcolor", ""),
    "sortable": generateComponentLinks("sortable", ""),
    "tab": generateComponentLinks("tab", ""),
    "toggle": generateComponentLinks("toggle", ""),
    "alert": generateComponentLinks("alert", ""),
    "notice": generateComponentLinks("notice", ""),
    "deprecatednotice": generateComponentLinks("deprecatednotice", ""),
    "svg": generateComponentLinks("svg", ""),
    "align": generateComponentLinks("align", ""),
    "query": generateComponentLinks("query", ""),
};

function generateComponentLinks(name, video_Link = "") {
    return {
        "videoLink": video_Link ? `https://www.youtube.com/watch?v=${video_Link}` : "",
        "document": `${wdkitData.WDKIT_DOC_URL}create-custom-elementor-widget-using-free-wdesignkit-widget-builder/#wkit-${name}-controller`,
    };
}
